module.exports = __webpack_public_path__ + "static/media/saddest.b6a14cd1.svg";